import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-percent",
  "use": "icon-percent-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol viewBox=\"0 0 80 80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-percent\">\n<circle opacity=\"0.2\" cx=\"40\" cy=\"40\" r=\"40\" fill=\"#36B27E\" />\n<path d=\"M30 50L50 30\" stroke=\"#36B27E\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<circle cx=\"32\" cy=\"32\" r=\"4\" fill=\"#36B27E\" />\n<circle cx=\"48\" cy=\"48\" r=\"4\" fill=\"#36B27E\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol